import React, {useState} from 'react';
import TextBox from '../components/textbox';
import ButtonComp from '../components/button';
import '../styling/containerStyles.css';
import DropDown from '../components/dropDown';
import Label from '../components/label';
import Button from '@material-ui/core/Button';
// import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import IconButton from '@material-ui/core/IconButton';
import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import WarningModal from '../components/modal';
// import pidiliteBlueLogo from '../assets/images/pidiliteBlueLogo.png';
// import saathiLogo from '../assets/images/saathiLogo.png';
// import feviSealLogo from '../assets/images/feviSealLogo.png';  
import leftChevron from '../assets/images/leftChevron.svg'; 
// import pidiliteTopBanner from '../assets/images/pidiliteTopBanner2.png';  

interface CustomerDetailsProps{
    division: string;
    handleToUpdateAdded:Function;
    banner: any;
}

export const CustomerDetails: React.FC<CustomerDetailsProps> = (props: CustomerDetailsProps) =>{

    const{
        division, handleToUpdateAdded, banner
    } = props;

    const [name, setName] = useState('')
    const [profession, setProfession] = useState('Select your profession')
    const [pincode, setPincode] = useState('')
    const [message, setMessage] = useState('')
    const [locationBlocked, setLocationBlocked] = useState(false)
    const [latitude , setLatitude] = useState(0)
    const [longitude , setLogitude] = useState(0)
    const [city , setCity] = useState('')

    const handleToUpdateContent = (name:string, arg: string) => {
        if(name === 'name')
            setName(arg)
    }

    const handleToUpdateProfession = (arg: string) => {
        setProfession(arg)
    }
    

    const handleToUpdateAdd = (arg: string) => {

        const data = {
            "name": name,
            "profession": profession,
            "pincode": pincode,
            "city" : city,
            "lat" : latitude,
            "long" : longitude
        }
        
        if(name.length === 0){
            setMessage('Please enter a valid name')
            setName('')
        }
        else if(profession === 'Select your profession' || profession === ""){
            setMessage('Please choose a valid profession ')
            setProfession('')
        }
        else if(pincode.length !== 6){
            setMessage('Invalid Pincode')
            setPincode('')
        }
        else
            handleToUpdateAdded(data)
        
    }

    const heading = "Location Disabled !!"
    const content = "Please allow location services"
    
    const getLocn = () => {
        navigator.geolocation.getCurrentPosition((pos) => {
            var geocoder = new google.maps.Geocoder();
            var latlng = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
            setLatitude(pos.coords.latitude)
            setLogitude(pos.coords.longitude)
            geocoder.geocode({ 'location': latlng }, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK && results[0]) {
                    for (var j = 0; j < results[0].address_components.length; j++) {
                        if (results[0].address_components[j].types[0] === 'postal_code') {
                            setPincode(results[0].address_components[j].long_name)
                        }
                        if (results[0].address_components[j].types[0] == "locality") {
                            setCity(results[0].address_components[j].long_name);
                        }
                    }
                        // var address = results[0].formatted_address.split(',')
                        // address = address[address.length-2].split(' ')
                        // setPincode(address[address.length - 1])
                }
            })
        })           
        navigator.permissions.query({
            name: 'geolocation'
        }).then(function(result) {
            if (result.state === 'denied') {
                setLocationBlocked(true)
            }
        });
    }
    
        let dropDownItems = [];
        if(division === 'FCC')
            dropDownItems = ['Select your profession', 'Contractor', 'Carpenter', 'Polisher']
        else
            dropDownItems = ['Select', 'Waterproofer', 'Kothi contractor', 'Painting Contractor', 'Plumbing Contractor', 'Mason', 'Others']
        
        return (
            <div className='homeWrap'>
                <div className='homeTop'>
                    {/* <div className='homeTopInner'>
                        <img src={pidiliteBlueLogo} alt='Pidilite Blue Logo' className='pidiliteLogo'/>
                        <img src={saathiLogo} alt='Saathi Logo' className='saathiLogo'/>
                        <div className='productLogoWrap'>
                            <img src={feviSealLogo} alt='Product Logo' className='productLogo'/>
                        </div>
                    </div> */}
                    <div className='homeTopBanner'>
                        <img src={banner} alt='Pidilite Top Banner' className='pidiliteTopBanner'/>
                    </div>
                </div>
                <div className='custDetails' >
                        {
                            locationBlocked && <WarningModal heading={heading} content={content} />
                        }
                        <div className='buttonAndLabel'>
                            <Button className='goBack back-btn' 
                            // onClick={() => {handleToUpdateAdded('GoBack')}}
                             >
                                <img src={leftChevron} alt='Left Chevron' className='leftChevron'/>
                                {/* <ArrowBackIosIcon /> */}
                            </Button> 
                            <Label content='Account Details' />
                        </div>
                        <br></br>
                        <Label content='Name' />
                        <TextBox className='textBox custom_input'
                                    label={'Name'} 
                                    state={'name'}
                                    placeholder={'Enter your name'} 
                                    handleToUpdate={handleToUpdateContent} />
                        <Label content='Profession' />
                        <DropDown item={dropDownItems} 
                                name='profession'
                                label='Profession' 
                                handleToUpdate={handleToUpdateProfession}/>
                        <Label content='Pincode' />
                        <div className='pincodeBox'>
                            <div className='box1'>
                                <TextBox className='textBox custom_input'
                                            label={'Pin Code'} 
                                            state={'pincode'}
                                            placeholder={'Eg: 560042'}
                                            defaultValue={pincode} 
                                            handleToUpdate={handleToUpdateContent}
                                            disabled={true} 
                                />    
                            </div>
                            <div className='box2'>
                                <IconButton 
                                    disabled={false}
                                    onClick={getLocn}
                                >
                                    <GpsFixedIcon />
                                </IconButton>
                            </div>
                        </div>

                        <div className='message'>{message}</div>
                        
                        <ButtonComp label= {'Pin Code'} 
                                name={'ADD'} 
                                visible={true}
                                handleToUpdate={handleToUpdateAdd}  />
                    
                    
                </div>  
            </div>          
        )
    }


export default CustomerDetails